import { Component, EventEmitter, input, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ModalComponent } from '@components/group-modals/components/modal/modal.component'
import { defaultModalInputValues } from '@components/group-modals/data/default-modal-input-values'

@Component({
  selector: 'app-modal-ok',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './modal-ok.component.html',
  styleUrls: ['./modal-ok.component.scss'],
})
export class ModalOkComponent {

  // signal inputs need ng17
  @Input({ required: true }) modalTitle: string
  disableButtons = input<boolean>(false)
  @Input() modalTitleCode: string
  @Input() modalIcon: string
  @Input() height: string
  @Input() width: string = defaultModalInputValues.width
  @Input() okText = 'OK'

  @Output() modalClose = new EventEmitter<void>()
  @Output() modalOk = new EventEmitter<void>()

  onModalClose() {
    this.modalClose.emit()
  }

  onModalOk() {
    this.modalOk.emit()
  }
}
